import { ICategory, ICategoryData } from ".";
import { IMetadata, Metadata } from "../metadata/metadata";

export class Category implements ICategory {
    groupId?: number;
    groupName: string;
    metadata?: IMetadata;
    productList: number[];
    subCategory?: Map<string, Category>;

    constructor(data: ICategoryData) {
        this.groupId = data.groupId
        this.groupName = data.groupName
        if (data.metadata) {
            this.metadata = new Metadata(data.metadata)
        }
        this.productList = []
        if (data.productList) {
            this.productList = data.productList.map((x) => x)
        }
        this.subCategory = new Map();
        if (data.subCategory) {
            for (const [key, val] of Object.entries(data.subCategory)) {
                this.subCategory?.set(key, new Category(val))
            }
        }
    }
    data(): ICategoryData {
        return Object.assign({}, this)
    }
}